import TestQuote from "./Quote"
import HeroSection from "./HeroSection"
import LogoShowcase from "./LogoShowcase"
import Article from "../molecules/news/ArticleCard"
import Case from "./CaseCard"
import FeatureHighlight from "./FeatureHighlight"
import Metadata from "./EmbeddedMetadata"

export type ContentfulEntryTypeName = keyof typeof ENTRIES_CONTENTFUL

export const ENTRIES_CONTENTFUL = {
  TestQuote,
  FeatureHighlight,
  HeroSection,
  LogoShowcase,
  Article,
  Case,
  Metadata,
}
